module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lt":{"meta":{"title":{"complement":"Nogrid","inner":"Saulės elektrinės namams","separator":"-"}},"title":"Saulės elektrinės namams","side":"Nogrid komanda jau įrengė daugiau nei 2000+ saulės elektrinių Lietuvoje. Savo patirtimi pasidalinsime su Jumis, kad įsigytumėte tinkamiausią sprendimą, leisiantį maksimaliai taupyti."}}')
  delete Component.options._Ctor
}
